import { Checkbox } from '@e2m-customer-portal/ui';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

const PAGE_TITLE_HEIGHT = 80;
const TOOLBAR_HEIGHT = 65;

interface RevenueGridHeaderProps {
  allSectionsOpen: boolean | null;
  showToggle: boolean;
  sidebarOffset?: number;
  toggleOpenSections: () => void;
}

export function RevenueGridHeader({
  allSectionsOpen,
  showToggle,
  sidebarOffset = 0,
  toggleOpenSections,
}: Readonly<RevenueGridHeaderProps>): ReactElement<RevenueGridHeaderProps> {
  const [t] = useTranslation();

  return (
    <div
      className="border-divider col-span-full hidden min-h-11 border-collapse grid-cols-5 gap-0 border-0 border-b border-solid sm:grid md:sticky md:z-[1202] md:bg-white"
      style={{ top: `${sidebarOffset + PAGE_TITLE_HEIGHT + TOOLBAR_HEIGHT}px` }}
    >
      <div className="border-divider col-span-2 box-border flex items-center justify-end border-0 border-r border-solid px-2 text-xs sm:text-sm lg:px-8">
        {showToggle && (
          <Checkbox
            className="m-0 flex cursor-pointer text-xs sm:text-sm appearance-none items-center border-none bg-transparent p-0"
            checked={!!allSectionsOpen}
            indeterminate={allSectionsOpen === null}
            onChange={toggleOpenSections}
            label={t('SHARED_EXPAND_ALL')}
            ariaLabel={t('SHARED_EXPAND_ALL')}
          />
        )}
      </div>
      <div className="border-divider col-span-1 box-border flex items-center justify-end border-0 border-r border-solid px-2 text-xs font-semibold sm:text-sm lg:px-8">
        {t('REVENUE_REPORT_TABLE_HEADER_AMOUNT')}
      </div>
      <div className="border-divider col-span-1 box-border flex items-center justify-end border-0 border-r border-solid px-2 text-xs font-semibold sm:text-sm lg:px-8">
        {t('REVENUE_REPORT_TABLE_HEADER_PRICE')}
      </div>
      <div className="col-span-1 box-border flex items-center justify-end px-2 text-xs font-semibold sm:text-sm lg:px-8">
        {t('REVENUE_REPORT_TABLE_HEADER_RESULT')}
      </div>
    </div>
  );
}
